import Cookies from 'universal-cookie'
import { getBaseURL } from '../../../../../GlobalComponents/URLs'

export const handleChooseAsset = (
    event,
    type,
    setNewFormId,
    setNewFormServiceType,
    setAssetServiceTypes,
    setNewFormAssetType,
    setNewFormCategory,
    setAssetTypes
) => {
    setNewFormId(-1)
    setNewFormServiceType('')
    setAssetServiceTypes(false)

    const setType = type === 'assetType' ? setNewFormAssetType : setNewFormCategory
    setType(event.target.value)

    if (!event.target.value || event.target.value === '') return

    const cookies = new Cookies(document.cookie)
    const cacheKey = `${type === 'assetType' ? 'serviceTypes' : 'assetTypes'}${
        event.target.value
    }${cookies.get('CoRoot')}`

    if (
        localStorage.getItem(cacheKey) &&
        localStorage.getItem(cacheKey) !== 'false' &&
        localStorage.getItem(cacheKey) !== 'null'
    ) {
        if (type === 'assetType') {
            setAssetServiceTypes(JSON.parse(localStorage.getItem(cacheKey)))
        } else {
            console.log('from cache')
            setAssetTypes(JSON.parse(localStorage.getItem(cacheKey)))
        }
    } else {
        fetch(
            `${getBaseURL()}webapi/form/${
                type === 'assetType' ? 'asset/service/types' : 'asset/types'
            }/${event.target.value}`,
            {
                credentials: 'include',
            }
        )
            .then((response) => response.json())
            .then((json) => {
                if (type === 'assetType') {
                    setAssetServiceTypes(json)
                } else {
                    console.log('from api')
                    setAssetTypes(json)
                }
            })
    }
}
